import { formatDateTime } from '@customerio/pluma-components/react/utils/formatted-date-time';

export const AccessSource = {
  TS: 'Support team',
  CS: 'Success team',
} as const;

export type AccessSource = (typeof AccessSource)[keyof typeof AccessSource];

export const DATACENTER_FLAGS: Record<string, string> = {
  us: '🇺🇸',
  eu: '🇪🇺',
};

export function formatDataCenter(dataCenter: string): string {
  const flag = DATACENTER_FLAGS[dataCenter] ?? '';
  return `${flag} ${dataCenter.toUpperCase()}`.trim();
}

export function formatShortDate(timestamp: number | undefined): string {
  if (timestamp == null || timestamp <= 0) return '';
  return formatDateTime(new Date(timestamp * 1000), 'medium');
}
